import React, { useState, useContext } from 'react'
import { useQuery } from '@apollo/client'
import sortBy from 'lodash/sortBy'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import StoriesInformation from './components/StoriesInformation'
import StoriesByTagAndType from './components/StoriesByTagAndType'
import StoriesGraph from './components/StoriesGraph'
import FilterInput from '../../components/FilterInput'
import { useStyles } from './styles'
import { GET_STORIES_DATA } from '../../network/stories/queries'
import { ALL_USERS_FILTER, NO_USERS_FILTER } from '../../constants/common'
import { MENU_PROPS } from '../../constants/theme'
import { LabContext } from '../../context'

const StoriesOverview = () => {
  const classes = useStyles()
  const { selectedLab, selectedAccount } = useContext(LabContext)
  const [filterValue, setFilterValue] = useState(ALL_USERS_FILTER)
  const { loading, data: storiesData } = useQuery(GET_STORIES_DATA, {
    skip: !selectedLab,
    variables: {
      labId: selectedLab,
      accountIds: selectedAccount ? [selectedAccount] : undefined,
      waveId: filterValue.id === ALL_USERS_FILTER.id ? undefined : filterValue.id === NO_USERS_FILTER.id ? null : filterValue.id
    },
    fetchPolicy: 'no-cache'
  })

  const handleFilterChange = value => {
    setFilterValue(value)
  }

  return loading || !selectedLab ? (
    <div className={classes.loader}>
      <CircularProgress color='inherit' />
    </div>
  ) : (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid container item xs={12} className={classes.toolbar}>
          <Typography variant='h2' component='div'>
            Stories Overview
          </Typography>
          <Select
            MenuProps={MENU_PROPS}
            value={filterValue.id}
            onChange={null}
            input={<FilterInput />}
            className={filterValue.id === ALL_USERS_FILTER.id ? '' : classes.nonDefault}
          >
            {[ALL_USERS_FILTER, ...sortBy(storiesData.coordinator.wave.list, 'name'), NO_USERS_FILTER].map(item => {
              return (
                <MenuItem key={item.id} onClick={() => handleFilterChange(item)} value={item.id} className={classes.menuItem}>
                  {item.name}
                </MenuItem>
              )
            })}
          </Select>
        </Grid>
        <Grid container item xs={12}>
          <StoriesInformation data={storiesData.coordinator.stats} />
          <StoriesByTagAndType data={storiesData.coordinator.stats} />
          <StoriesGraph data={storiesData.coordinator.stats} />
        </Grid>
      </Grid>
    </div>
  )
}

export default StoriesOverview
